import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import NavbarPortal from "../../Components/Navbar";
import FooterPortal from "../../Components/Footer";
import { IoIosArrowForward } from "react-icons/io";
import { FaHotjar } from "react-icons/fa";
import KategoriPageSkeleton from "../../Components/Skeleton/KategoriPageSkeleton";

type Editorial = {
  id: number;
  judul: string;
  gambar: string;
  kategori: string;
  created_at: string;
};

const API = process.env.REACT_APP_API_BASE_URL;

const KategoriPage = () => {
  const { kategori } = useParams();

  const [news, setNews] = useState<Editorial[]>([]);
  const [loading, setLoading] = useState(true);
  const [popular, setPopular] = useState<Editorial[]>([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    fetchNews();
    fetchPopular();
  }, [kategori, page]);

  const fetchNews = async () => {
    setLoading(true);

    const url = kategori === "semua" ? `${API}/api/editorial?page=${page}` : `${API}/api/editorial?kategori_web=${kategori}&page=${page}`;

    const res = await axios.get(url);

    setNews(res.data.data);
    setLastPage(res.data.last_page);

    setLoading(false);
  };

  const fetchPopular = async () => {
    const res = await axios.get(`${API}/api/editorial-populer`);
    setPopular(res.data.data);
  };

  if (loading) {
    return (
      <>
        <NavbarPortal />
        <KategoriPageSkeleton />
        <FooterPortal />
      </>
    );
  }

  return (
    <>
      <NavbarPortal />

      <div className="max-w-7xl mx-auto px-4 py-6 font-signika">
        {/* TITLE */}

        <div>
          <div className="text-gray-400 text-sm flex items-center gap-1">
            Home <IoIosArrowForward /> {kategori}
          </div>
          <h1 className="text-3xl font-bold mb-6 uppercase text-primary">{kategori}</h1>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* LEFT CONTENT */}
          <div className="lg:col-span-2">
            {/* NEWS GRID */}
            <div className="grid md:grid-cols-2 gap-6">
              {news.map((item) => (
                <div key={item.id} className="group cursor-pointer">
                  <Link to={`/berita/${item.id}`}>
                    <img alt="" src={item.gambar} className="w-full h-[200px] object-cover rounded-lg" />
                  </Link>

                  <Link to={`/berita/${item.id}`}>
                    <h2 className="mt-3 font-semibold text-lg group-hover:text-primary">{item.judul}</h2>
                  </Link>

                  <span className="text-sm text-gray-500">
                    {new Date(item.created_at).toLocaleDateString("id-ID", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                </div>
              ))}
            </div>

            {/* PAGINATION */}

            <div className="flex justify-center mt-10 gap-2">
              {[...Array(lastPage)].map((_, i) => (
                <button
                  key={i}
                  onClick={() => setPage(i + 1)}
                  className={`px-4 py-2 rounded 
                ${page === i + 1 ? "bg-primary text-white" : "bg-gray-200"}`}>
                  {i + 1}
                </button>
              ))}
            </div>
          </div>

          {/* SIDEBAR */}

          <div>
            <div className="flex items-center gap-3 mb-4 border-b pb-2">
              <FaHotjar className="w-5 h-5 text-primary" />

              <h2 className="font-bold ">Isu Populer</h2>
            </div>

            <div className="space-y-4">
              {popular.map((item) => (
                <div key={item.id} className="flex gap-3">
                  <Link to={`/berita/${item.id}`}>
                    <img alt="" src={item.gambar} className="w-[80px] h-[60px] object-cover rounded" />
                  </Link>

                  <div>
                    <Link to={`/berita/${item.id}`}>
                      <p className="text-sm font-medium leading-snug">{item.judul}</p>
                    </Link>

                    <span className="text-xs text-gray-500">
                      {new Date(item.created_at).toLocaleDateString("id-ID", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <FooterPortal />
    </>
  );
};

export default KategoriPage;
